import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#b45309", amberBg: "#fffbeb", amberBorder: "#fde68a",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:     <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:    <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    MapPin:        <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Users:         <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    ShieldCheck:   <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    Star:          <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    Heart:         <><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></>,
    Zap:           <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    TrendingUp:    <><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></>,
    BadgeCheck:    <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Handshake:     <><path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/><path d="m21 3 1 11h-1"/><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"/><path d="M3 4h8"/></>,
    Lightbulb:     <><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></>,
    Globe:         <><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></>,
    Phone:         <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.34 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.09a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></>,
    Mail:          <><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></>,
    CheckCircle:   <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    Sparkles:      <><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/></>,
    Quote:         <><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ── Value card ── */
function ValueCard({ icon, title, desc }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "26px 24px", borderRadius: 16,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .2s cubic-bezier(.4,0,.2,1)",
        display: "flex", flexDirection: "column", gap: 14,
      }}>
      <div style={{
        width: 44, height: 44, borderRadius: 13,
        background: hovered ? T.g100 : T.n50,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "all .2s",
      }}>
        <Icon name={icon} size={20} color={hovered ? T.g600 : T.n400} strokeWidth={1.6} />
      </div>
      <div>
        <div style={{ fontFamily: T.sans, fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 8, letterSpacing: "-0.01em" }}>{title}</div>
        <p style={{ fontFamily: T.sans, fontSize: 14, color: T.n600, lineHeight: 1.75, margin: 0 }}>{desc}</p>
      </div>
    </div>
  );
}

/* ── Stat block ── */
function StatBlock({ value, label, sub }) {
  return (
    <div style={{ padding: "28px 24px", textAlign: "center" }}>
      <div style={{ fontFamily: T.serif, fontSize: "clamp(32px,5vw,48px)", fontWeight: 400, color: T.g600, letterSpacing: "-0.04em", lineHeight: 1, marginBottom: 8 }}>{value}</div>
      <div style={{ fontFamily: T.sans, fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 4 }}>{label}</div>
      {sub && <div style={{ fontFamily: T.sans, fontSize: 12, color: T.n400, lineHeight: 1.5 }}>{sub}</div>}
    </div>
  );
}

/* ── Team member ── */
function TeamMember({ name, role, bio, initials, colorSet }) {
  return (
    <div style={{ display: "flex", gap: 18, alignItems: "flex-start", padding: "28px 0", borderBottom: `1px solid ${T.n100}` }}>
      <div style={{
        width: 52, height: 52, borderRadius: 14, flexShrink: 0,
        background: colorSet.bg, border: `1.5px solid ${colorSet.border}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: T.sans, fontSize: 16, fontWeight: 600, color: colorSet.text,
        letterSpacing: "0.02em",
      }}>
        {initials}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontFamily: T.sans, fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 2 }}>{name}</div>
        <div style={{ fontFamily: T.sans, fontSize: 12, fontWeight: 600, color: T.g600, letterSpacing: "0.05em", textTransform: "uppercase", marginBottom: 10 }}>{role}</div>
        <p style={{ fontFamily: T.sans, fontSize: 14, color: T.n600, lineHeight: 1.75, margin: 0 }}>{bio}</p>
      </div>
    </div>
  );
}

/* ── Timeline item ── */
function TimelineItem({ period, title, desc, isLast }) {
  return (
    <div style={{ display: "flex", gap: 20, position: "relative" }}>
      {!isLast && (
        <div style={{ position: "absolute", left: 15, top: 36, bottom: -8, width: 1, background: `linear-gradient(to bottom, ${T.g200}, ${T.n150})` }} />
      )}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
        <div style={{ width: 32, height: 32, borderRadius: "50%", background: T.g50, border: `2px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1 }}>
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: T.g500 }} />
        </div>
      </div>
      <div style={{ flex: 1, paddingBottom: isLast ? 0 : 36 }}>
        <div style={{ fontFamily: T.sans, fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 5 }}>{period}</div>
        <div style={{ fontFamily: T.sans, fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 6, letterSpacing: "-0.01em" }}>{title}</div>
        <p style={{ fontFamily: T.sans, fontSize: 14, color: T.n600, lineHeight: 1.75, margin: 0 }}>{desc}</p>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function AboutPage() {
  useFonts();
  const navigate = useNavigate();

  const VALUES = [
    {
      icon: "ShieldCheck",
      title: "Trust is the product",
      desc: "Before anyone books through JiraniApp, every professional has been identity-verified and reviewed by our team. Trust is not a feature we added -- it is the reason the platform works.",
    },
    {
      icon: "Handshake",
      title: "Fair to both sides",
      desc: "We believe the professional who shows up deserves to be paid fairly and on time, and the client who pays deserves excellent work. We hold both sides to the same standard.",
    },
    {
      icon: "MapPin",
      title: "Built for here, not adapted from there",
      desc: "JiraniApp was designed around M-Pesa, Kenyan neighbourhoods, and the way home services actually get booked here. Not a copy of something built for a different market.",
    },
    {
      icon: "TrendingUp",
      title: "Pros deserve a real career path",
      desc: "A great plumber or electrician working consistently through JiraniApp should be able to build a livelihood, grow a reputation, and eventually run a team. We are building toward that.",
    },
    {
      icon: "Lightbulb",
      title: "Simple on purpose",
      desc: "Booking a service should not require a tutorial. We make the hard things -- verification, payments, scheduling, disputes -- invisible to the user so the experience feels effortless.",
    },
    {
      icon: "Heart",
      title: "Community, not just commerce",
      desc: "Jirani means neighbour. Every booking connects someone who needs help with someone local who can provide it. That relationship matters more than the transaction.",
    },
  ];

  const TEAM = [
    {
      name: "Morris Mwendwa Kyalo",
      role: "Founder and CEO",
      initials: "MK",
      colorSet: { bg: T.g50, text: T.g700, border: T.g100 },
      bio: "Morris holds a degree in Finance and spent four years in corporate banking, structuring working capital facilities for small and medium enterprises across Nairobi. That work put him face to face with how much of Kenya's services economy still runs on cash, trust, and improvisation -- and convinced him it needed a payment and verification layer built around M-Pesa, not against it. He left banking to build that layer, and now leads strategy, finance, and partnerships at JiraniApp.",
    },
    {
      name: "Agnes Mutinda Kaviku",
      role: "Co-Founder and COO",
      initials: "AK",
      colorSet: { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
      bio: "Agnes holds a Master's in Agribusiness Management and spent over five years building and managing distributed supplier networks for agricultural cooperatives across Eastern and Central Kenya -- recruiting members, setting quality standards, and coordinating logistics across dozens of counties with limited infrastructure. Running a distributed, trust-dependent network at that scale is exactly the discipline JiraniApp's professional base needs as it grows. Agnes now leads operations, professional vetting, and expansion into new counties.",
    },
  ];

  const TIMELINE = [
    {
      period: "January 2026",
      title: "The idea",
      desc: "Morris had spent years in corporate banking, watching small businesses run on cash, trust, and improvisation. Agnes had spent years building distributed networks of independent agricultural suppliers across rural Kenya who'd never met each other and barely knew her. Comparing notes, they realized the same missing layer -- verified trust -- was holding back Kenya's entire home services market.",
    },
    {
      period: "February 2026",
      title: "First build",
      desc: "A working prototype in under six weeks. Fifteen plumbers and electricians in Westlands agreed to try it before it even had a name.",
    },
    {
      period: "April 2026",
      title: "First bookings, first proof",
      desc: "The first real booking happened on a Tuesday morning -- a client in Kilimani booked a plumber, the plumber showed up, got paid through M-Pesa, and left a job record in the app. It worked, and it kept working.",
    },
    {
      period: "June 2026",
      title: "Where we are now",
      desc: "JiraniApp is live with hundreds of verified JiraniPros across fourteen service categories, growing every week. We are five months in. Nearly everything is still ahead of us.",
    },
  ];

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0 }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/contact")} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: `1px solid ${T.n200}`, cursor: "pointer", color: T.n600, fontSize: 13, fontFamily: T.sans, padding: "8px 16px", borderRadius: 8, fontWeight: 500 }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.n400; e.currentTarget.style.color = T.n900; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
          <Icon name="Mail" size={13} strokeWidth={2} />
          Get in touch
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(56px,8vw,104px) 20px clamp(48px,6vw,80px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 24 }}>
            <Icon name="Sparkles" size={14} color={T.g500} strokeWidth={2.2} />
            About JiraniApp
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(40px,7.5vw,72px)", fontWeight: 400, margin: "0 0 24px", lineHeight: 1.04, color: T.n900, letterSpacing: "-0.03em", maxWidth: 660 }}>
            Kenya's hardest workers<br/>
            deserved more than<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>word of mouth</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.8, margin: "0 0 0", maxWidth: 520 }}>
            JiraniApp is the trust layer behind home services in Kenya -- verified professionals,
            secure M-Pesa payments, and a reputation built entirely on real, completed work.
          </p>
        </div>
      </div>

      {/* ══ STATS STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))" }}>
          {[
            { value: "350+",  label: "Verified JiraniPros",     sub: "across Kenya, growing weekly" },
            { value: "14",    label: "Service categories",       sub: "plumbing, electrical, cleaning and more" },
            { value: "24h",   label: "M-Pesa payout",            sub: "after every completed job" },
            { value: "2026",  label: "Founded in Nairobi",       sub: "built for Kenya from day one" },
          ].map((s, i) => (
            <div key={i} style={{ borderRight: i < 3 ? `1px solid ${T.n100}` : "none" }}>
              <StatBlock {...s} />
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px clamp(80px,10vw,120px)" }}>

        {/* ══ THE PROBLEM WE ARE SOLVING ══ */}
        <div style={{ paddingTop: "clamp(52px,7vw,72px)", marginBottom: "clamp(52px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 14px" }}>Why we exist</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(28px,4.5vw,40px)", fontWeight: 400, color: T.n900, margin: "0 0 0", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            The hardest workers in Kenya<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>were also the easiest to overlook</em>
          </h2>

          {/* Founder's letter */}
          <div style={{ margin: "36px 0", padding: "32px 36px", borderLeft: `4px solid ${T.g400}`, background: T.g50, borderRadius: "0 14px 14px 0" }}>
            <div style={{ marginBottom: 14 }}>
              <Icon name="Quote" size={20} color={T.g300} strokeWidth={1.4} />
            </div>
            <p style={{ fontFamily: T.serif, fontSize: "clamp(17px,2.6vw,20px)", color: T.g800, lineHeight: 1.7, margin: "0 0 18px", letterSpacing: "-0.005em", fontStyle: "italic" }}>
              I didn't start JiraniApp because I found a gap in a market report. I started it because of the people I grew up around -- the mama fua who came every Saturday for eleven straight years and still had to renegotiate her rate from scratch each time. The fundi who could rewire an entire house from memory, but had no way to show a new client he was the same man who'd done three other homes on the same street.
            </p>
            <p style={{ fontFamily: T.serif, fontSize: "clamp(17px,2.6vw,20px)", color: T.g800, lineHeight: 1.7, margin: "0 0 18px", letterSpacing: "-0.005em", fontStyle: "italic" }}>
              These are some of the hardest-working people in the country, and the systems around them never matched that effort. No verified record of who was good. No protection when a job went wrong, for either side. No way for years of reliable work to add up to anything more than the next single job.
            </p>
            <p style={{ fontFamily: T.serif, fontSize: "clamp(17px,2.6vw,20px)", color: T.g800, lineHeight: 1.7, margin: "0 0 18px", letterSpacing: "-0.005em", fontStyle: "italic" }}>
              JiraniApp exists to close that gap -- identity verification, secure M-Pesa payments held until the job is done, and a reputation that's earned through real, completed work and travels with you. Quiet infrastructure, not a campaign.
            </p>
            <p style={{ fontFamily: T.serif, fontSize: "clamp(17px,2.6vw,20px)", color: T.g800, lineHeight: 1.7, margin: "0 0 20px", letterSpacing: "-0.005em", fontStyle: "italic" }}>
              We started building in 2026. There's far more ahead of us than behind us. But the idea at the center of this company hasn't changed since the first conversation: when good work is made visible and trustworthy, it finds its way to the people who need it. We're building JiraniApp to make sure it does, at scale, in every neighbourhood in Kenya.
            </p>
            <div style={{ fontFamily: T.sans, fontSize: 13, fontWeight: 600, color: T.g700 }}>Morris Mwendwa Kyalo, Founder and CEO</div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 0 }}>
            {[
              {
                label: "No record that good work happened",
                body: "A professional could do excellent work for years with nothing to show for it beyond word of mouth that rarely travelled past one estate.",
              },
              {
                label: "No protection for either side",
                body: "If a job went badly, clients had no recourse. If a client didn't pay, the professional had no protection. The informal nature of the work left everyone exposed.",
              },
              {
                label: "Cash created friction, not trust",
                body: "Negotiating cash at the door, with no receipt and no record, made every job feel like it was starting from zero -- for people who had already proven themselves dozens of times over.",
              },
              {
                label: "Skill alone wasn't enough to grow",
                body: "A brilliant electrician with no digital presence and no marketing budget stayed capped at the same handful of clients for years, no matter how good the work was.",
              },
            ].map((item, i) => (
              <div key={i} style={{ padding: "24px 0", borderBottom: `1px solid ${T.n100}`, display: "flex", gap: 16 }}>
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: T.g400, flexShrink: 0, marginTop: 8 }} />
                <div>
                  <div style={{ fontFamily: T.sans, fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 8, letterSpacing: "-0.01em" }}>{item.label}</div>
                  <p style={{ fontFamily: T.sans, fontSize: 14, color: T.n600, lineHeight: 1.75, margin: 0 }}>{item.body}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 36, padding: "28px 32px", borderRadius: 16, background: T.n50, border: `1px solid ${T.n150}` }}>
            <p style={{ fontFamily: T.sans, fontSize: 15, color: T.n700, lineHeight: 1.8, margin: 0 }}>
              JiraniApp fixes this at the infrastructure level: verified identity, secure M-Pesa payments, and a review
              system tied only to real, completed bookings. Not flashy -- just the dependable layer that lets hard work
              actually compound into something.
            </p>
          </div>
        </div>

        {/* ══ OUR VALUES ══ */}
        <div style={{ marginBottom: "clamp(52px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 14px" }}>What we stand for</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(28px,4.5vw,40px)", fontWeight: 400, color: T.n900, margin: "0 0 32px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            The values we <em style={{ fontStyle: "italic", color: T.g600 }}>actually build by</em>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(270px, 1fr))", gap: 14 }}>
            {VALUES.map((v, i) => <ValueCard key={i} {...v} />)}
          </div>
        </div>

        {/* ══ OUR STORY / TIMELINE ══ */}
        <div style={{ marginBottom: "clamp(52px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 14px" }}>Our story</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(28px,4.5vw,40px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            How we got <em style={{ fontStyle: "italic", color: T.g600 }}>here</em>
          </h2>
          <p style={{ fontFamily: T.sans, fontSize: 15, color: T.n400, margin: "0 0 36px", lineHeight: 1.65 }}>
            JiraniApp is early. Here is the honest version of how it started and where things stand.
          </p>
          <div style={{ paddingLeft: 4 }}>
            {TIMELINE.map((item, i) => (
              <TimelineItem key={i} {...item} isLast={i === TIMELINE.length - 1} />
            ))}
          </div>
        </div>

        {/* ══ TEAM ══ */}
        <div style={{ marginBottom: "clamp(52px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 14px" }}>The team</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(28px,4.5vw,40px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Two founders, <em style={{ fontStyle: "italic", color: T.g600 }}>one conviction</em>
          </h2>
          <p style={{ fontFamily: T.sans, fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            JiraniApp is built by two people who've each spent years inside the exact problems we're solving.
          </p>
          <div style={{ marginTop: 8 }}>
            {TEAM.map((member, i) => <TeamMember key={i} {...member} />)}
          </div>

          {/* Hiring note */}
          <div style={{ marginTop: 32, padding: "22px 24px", borderRadius: 14, background: T.amberBg, border: `1px solid ${T.amberBorder}`, display: "flex", gap: 14, alignItems: "flex-start" }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: T.white, border: `1px solid ${T.amberBorder}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon name="Zap" size={16} color={T.amber} strokeWidth={1.8} />
            </div>
            <div>
              <div style={{ fontFamily: T.sans, fontSize: 14, fontWeight: 600, color: "#92400e", marginBottom: 5 }}>We are hiring carefully</div>
              <p style={{ fontFamily: T.sans, fontSize: 14, color: "#92400e", lineHeight: 1.7, margin: "0 0 10px" }}>
                We are looking for people who care about the problem, not just the opportunity. If you are interested in Trust and Safety, operations, product, or engineering in a context where the work has real stakes for real people -- we would like to hear from you.
              </p>
              <button onClick={() => navigate("/contact")} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", color: T.amber, fontSize: 13, fontWeight: 600, fontFamily: T.sans, padding: 0 }}
                onMouseEnter={e => e.currentTarget.style.opacity = "0.75"}
                onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
                Reach out <Icon name="ArrowRight" size={13} color={T.amber} strokeWidth={2.5} />
              </button>
            </div>
          </div>
        </div>

        {/* ══ FOR INVESTORS / PRESS ══ */}
        <div style={{ marginBottom: "clamp(52px,7vw,72px)", padding: "clamp(28px,5vw,44px)", borderRadius: 18, border: `1px solid ${T.n150}`, background: T.n50 }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 14px" }}>Press and investors</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,34px)", fontWeight: 400, color: T.n900, margin: "0 0 14px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Working on a story or<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>interested in what we are building?</em>
          </h2>
          <p style={{ fontFamily: T.sans, fontSize: 15, color: T.n600, lineHeight: 1.75, margin: "0 0 24px", maxWidth: 480 }}>
            We're happy to talk to journalists covering Kenya's tech ecosystem, the informal services economy, or the future of work.
            If you're an investor interested in what we're building, reach out directly -- we'll share whatever you need.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <button onClick={() => navigate("/contact")} style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: T.g500, color: T.white, border: "none",
              padding: "13px 26px", borderRadius: 10, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans, letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Get in touch
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <a href="mailto:press@jiraniapp.co.ke" style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, textDecoration: "none",
              padding: "13px 26px", borderRadius: 10, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans, letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              <Icon name="Mail" size={15} color={T.n500} strokeWidth={2} />
              press@jiraniapp.co.ke
            </a>
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{ padding: "clamp(36px,5vw,56px)", borderRadius: 20, border: `1px solid ${T.g100}`, textAlign: "center", background: T.g50 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.white, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="Globe" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4vw,38px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Come be part of<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>what we are building</em>
          </h2>
          <p style={{ fontFamily: T.sans, fontSize: 15, color: T.n400, margin: "0 auto 32px", lineHeight: 1.75, maxWidth: 400 }}>
            Whether you need a service professional, want to offer your skills, or just want to follow along -- there is a place for you here.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/search")} style={{
              padding: "14px 32px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Find a professional
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/become-a-pro")} style={{
              padding: "14px 28px", background: "transparent", color: T.g700,
              border: `1.5px solid ${T.g200}`, borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.g400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.g200}>
              Become a JiraniPro
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}